import { render, staticRenderFns } from "./CreateWaitTimeRuleContent.vue?vue&type=template&id=14960e63&scoped=true&"
import script from "./CreateWaitTimeRuleContent.vue?vue&type=script&lang=js&"
export * from "./CreateWaitTimeRuleContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateWaitTimeRuleContent.vue?vue&type=style&index=0&id=14960e63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14960e63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14960e63')) {
      api.createRecord('14960e63', component.options)
    } else {
      api.reload('14960e63', component.options)
    }
    module.hot.accept("./CreateWaitTimeRuleContent.vue?vue&type=template&id=14960e63&scoped=true&", function () {
      api.rerender('14960e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/ModalComponents/CreateWaitTimeRuleContent.vue"
export default component.exports